// extracted by mini-css-extract-plugin
export var buttonHolder = "index-module--button-holder--k8ceR";
export var corporateMemphisHorse = "index-module--corporateMemphisHorse--1QvPR";
export var ___gatsby = "index-module--___gatsby--sjSOq";
export var gatsbyFocusWrapper = "index-module--gatsby-focus-wrapper--KqQN+";
export var horseButton = "index-module--horseButton--0dMvG";
export var twoStables = "index-module--twoStables--KBvof";
export var horseText = "index-module--horse-text--IQV1x";